import React from "react";
import "./loading.scss";

const Loading: React.FC = (props) => (
    <div className="loading">{props.children ? props.children : <p>Loading...</p>}</div>
);

export default Loading;
